import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { PendingInterceptor } from 'common/services/http-interceptor/pending-interceptor';
import * as _ from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map, scan, startWith } from 'rxjs/operators';

@Component({
  selector: 'ui-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: [ './loading-bar.component.less' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingBarComponent implements OnInit {
  public filteredUrlPatterns: string[] = [ 'login', 'index.html' ];
  public mode: string = 'indeterminate';
  public showBar$!: Observable<boolean>;

  constructor(
    private pendingRequestInterceptorService: PendingInterceptor,
    private router: Router
  ) { }

  ngOnInit(): void {
    // The loading bar should be shown until both network calls and navigation events have completed
    const navigationLoading$ = this.router.events.pipe(
      // Keep state across all router events; only start/end should toggle the loading flag.
      scan((isLoading, routerEvent) => {
        if (routerEvent instanceof NavigationStart) {
          return true;
        }

        if (routerEvent instanceof NavigationEnd) {
          return false;
        }

        return isLoading;
      }, false),
      startWith(false),
      distinctUntilChanged()
    );

    this.showBar$ = combineLatest([
      this.pendingRequestInterceptorService.pendingRequestsStatus.pipe(startWith(false)),
      navigationLoading$
    ]).pipe(
      map(([ networkPending, navigationLoading ]) => networkPending || navigationLoading),
      distinctUntilChanged()
    );

    if (!(this.filteredUrlPatterns instanceof Array)) {
      throw new TypeError('`filteredUrlPatterns` must be an array.');
    }

    if (this.filteredUrlPatterns.length) {
      this.filteredUrlPatterns.forEach((e) => {
        let regExpVal = new RegExp(e);
        if (!_.find(this.pendingRequestInterceptorService.filteredUrlPatterns, (val: any) => _.isEqual(val, regExpVal))) {
          this.pendingRequestInterceptorService.filteredUrlPatterns.push(regExpVal);
        }
      });
    }
  }

}
